import React, { useState } from 'react';
import { FIELD_PRESETS, buildFieldFromPreset } from '../adapters';

const FY_PRESET_IDS = new Set(['FY_SD_RATE', 'FY_GST_RATE', 'FY_IT_RATE', 'FY_LABOUR_CESS_RATE']);

const PresetPickerDialog = ({ open, sectionCode, existingCodes, onClose, onSubmit }) => {
  const [selected, setSelected] = useState([]);
  if (!open) return null;

  const toggle = (id) => {
    setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const selectFyDefaults = () => {
    setSelected((prev) => Array.from(new Set([...prev, ...FY_PRESET_IDS])));
  };

  const submit = () => {
    let codes = [...existingCodes];
    const fields = [];
    selected.forEach((id) => {
      const preset = FIELD_PRESETS.find((p) => p.id === id);
      if (!preset) return;
      const field = buildFieldFromPreset(preset, { sectionCode: sectionCode || preset.sectionHint, existingCodes: codes });
      codes.push(field.fieldCode);
      fields.push(field);
    });
    onSubmit(fields);
    setSelected([]);
    onClose();
  };

  const fyPresets = FIELD_PRESETS.filter((p) => FY_PRESET_IDS.has(p.id));
  const otherPresets = FIELD_PRESETS.filter((p) => !FY_PRESET_IDS.has(p.id));

  return (
    <div className="ra-tpl-modal-overlay" onClick={onClose}>
      <div className="ra-tpl-modal ra-tpl-modal--wide" onClick={(e) => e.stopPropagation()}>
        <h3>Add Common RA Field</h3>
        <p className="ra-tpl-help">Presets are starting configurations — rates and bases can be changed after adding.</p>

        <div className="ra-tpl-preset-group">
          <div className="ra-tpl-preset-group__head">
            <h4>FY Recovery Rates (department)</h4>
            <button type="button" className="btn-secondary btn-sm" onClick={selectFyDefaults}>
              Select all 4 FY rates
            </button>
          </div>
          <p className="ra-tpl-help">
            Default fields for SD / GST / IT / Labour cess %. Values come from Admin → Departments FY rules (fallback if no FY rule).
          </p>
          <div className="ra-tpl-intent-grid">
            {fyPresets.map((p) => (
              <button
                key={p.id}
                type="button"
                className={`ra-tpl-intent-card ${selected.includes(p.id) ? 'is-active' : ''}`}
                onClick={() => toggle(p.id)}
              >
                {p.label}
              </button>
            ))}
          </div>
        </div>

        <h4 style={{ marginTop: 16 }}>Other common fields</h4>
        <div className="ra-tpl-intent-grid">
          {otherPresets.map((p) => (
            <button
              key={p.id}
              type="button"
              className={`ra-tpl-intent-card ${selected.includes(p.id) ? 'is-active' : ''}`}
              onClick={() => toggle(p.id)}
            >
              {p.label}
            </button>
          ))}
        </div>
        <div className="ra-tpl-modal-actions">
          <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
          <button type="button" className="btn-primary" disabled={!selected.length} onClick={submit}>
            Add {selected.length || ''} Field{selected.length === 1 ? '' : 's'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PresetPickerDialog;
